import React from 'react';
import { InlineWidget } from 'react-calendly';
import { X } from 'lucide-react';

const CalendlyModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  // Calendly customization options
  const pageSettings = {
    backgroundColor: 'ffffff',
    hideEventTypeDetails: false,
    hideLandingPageDetails: false,
    primaryColor: '667eea', // Purple to match your brand
    textColor: '1e293b',    // Slate-900 for text
    hideGdprBanner: true
  };

  const utm = {
    utmCampaign: 'PMS Kart Website',
    utmSource: 'pmskart.com',
    utmMedium: 'website',
    utmContent: 'hero_button'
  };

  return (
    <div 
      className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4"
      onClick={onClose}
    >
      <div 
        className="bg-white rounded-lg shadow-2xl w-full max-w-4xl max-h-[90vh] overflow-hidden"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Modal Header */}
        <div className="flex items-center justify-between p-6 border-b border-slate-200">
          <div>
            <h2 className="text-2xl font-bold text-slate-900">Schedule a Meeting</h2>
            <p className="text-sm text-slate-600 mt-1">Choose a time that works best for you</p>
          </div>
          <button 
            onClick={onClose}
            className="p-2 hover:bg-slate-100 rounded-full transition-colors"
          >
            <X className="w-6 h-6 text-slate-600" />
          </button>
        </div>

        {/* Calendly Widget */}
        <div className="p-6" style={{ height: '650px' }}>
          <InlineWidget 
            url="https://calendly.com/contact-pmskart/30min"
            pageSettings={pageSettings}
            utm={utm}
            styles={{
              height: '100%',
              width: '100%'
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default CalendlyModal;
